import NewIek from './new-iek';
import NewItk from './new-itk';
import OldItk from './old-itk';
import { TEMPLATE } from '../../config';
import Generica from './generica';

const templates = {
    new_iek: NewIek,
    new_itk: NewItk,
    old_itk: OldItk,
    generica: Generica,
};
const Component = templates[TEMPLATE] || (() => <h1>Произошла ошибка</h1>);

// @ts-ignore какой-то баг в тс
export default Component;
